import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { API } from '../../../../services/Api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GetCapabilities, GetAllCapabilitiesOfRoles, AddCapability, RemoveCapability, GetAllRoles, AddRemoveCapability, ResetCapability } from '../store/capabilities.actions';
import { MatDialog, MatDialogRef } from '@angular/material';
import { AddRoleComponent } from '../add-role/add-role.component';
import { EditRoleComponent } from '../edit-role/edit-role.component';
import { LoaderShow, LoaderHide } from 'src/app/features/loader/store/loader.actions';
import { Location } from '@angular/common';
import { GetConfigurations } from '../../configurations/store/configurations.actions';
import { NotificationModalComponent } from "../../../common-components/notification-modal/notification-modal.component";



@Component({
    selector: 'app-list-capabilities',
    templateUrl: './list-capabilities.component.html',
    styleUrls: ['./list-capabilities.component.scss']
})
export class ListCapabilitiesComponent implements OnInit {
    capabilitiesList: any;
    allCapabilitiesOfRolesList: any;
    rolesList: any = [' '];
    dataObj: any;
    capabilitiesForm: any;
    role: string;
    targetId: string;
    tempRoleList: any;
    tableHeaderList;
    capTooltip: string;
    categorisedObj = {};
    finalList: any;
    editRoleCapability: boolean = false

    constructor(
        private store: Store<AppState>,
        private api: API,
        private router: Router,
        private fb: FormBuilder,
        private dialog: MatDialog,
        private ref: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private location: Location) { }

    ngOnInit() {
        this.capabilitiesForm = this.fb.group({
            role: []
        });

        this.store.dispatch(new LoaderShow())
        this.store.dispatch(new GetCapabilities());
        this.store.dispatch(new GetAllCapabilitiesOfRoles());
        this.store.dispatch(new GetAllRoles());
        this.store.dispatch(new GetConfigurations());

        // this.store.dispatch(new GetAllRoles());

        this.store.select(state => state.configurations.configurations).subscribe(res => {
            if (res['editRole']) {
                this.editRoleCapability = res['editRole']['value'] === 'true' ? true : false
            }
        })

        this.store.select(state => state.capabilities.capabilities).subscribe(capabilities => {
            this.dataObj = {};
            this.capabilitiesList = capabilities['capabilities'];
            // this.store.dispatch(new GetAllCapabilitiesOfRoles());
            this.store.select(state => state.capabilities.allCapabilitiesOfRoles).subscribe(allCapabilitiesOfRoles => {
                this.allCapabilitiesOfRolesList = allCapabilitiesOfRoles['data'];
                // this.store.dispatch(new GetAllRoles());
                this.store.select(state => state.capabilities.roles).subscribe(roles => {
                    this.store.dispatch(new LoaderShow())
                    this.rolesList = [];
                    this.tableHeaderList = [];
                    this.rolesList = roles;
                    if (this.rolesList.filter(role => role.role.includes('empty')).length === 0) {
                        this.rolesList.unshift({
                            role: 'empty',
                            description: ''
                        });
                    }

                    this.tableHeaderList = this.rolesList.map(role => role.role);
                    if (typeof this.capabilitiesList !== 'undefined' && typeof this.allCapabilitiesOfRolesList !== 'undefined') {
                        Object.keys(this.capabilitiesList).forEach(capCategory => {
                            // this.dataObj[capCategory] = [{type: 'category', value : capCategory}];
                            const capabilitiesLst = this.capabilitiesList[capCategory];
                            // tslint:disable-next-line:forin
                            for (const cap in capabilitiesLst) {
                                const capabilityDesc = {
                                    shortDesc: capabilitiesLst[cap].shortDescription,
                                    longDesc: capabilitiesLst[cap].description,
                                    category: capabilitiesLst[cap].category
                                };
                                const capability = capabilitiesLst[cap].capability;
                                this.dataObj[capability] = [];
                                this.rolesList.forEach(role => {
                                    const roleCapabilty = {};
                                    this.allCapabilitiesOfRolesList.map((item: any) => {
                                        roleCapabilty[item.role] = item.capabilities;
                                        return roleCapabilty;
                                    });
                                    if (role.role === 'empty') {
                                        this.dataObj[capability].push(capabilityDesc);
                                    } else {
                                        // tslint:disable-next-line:max-line-length
                                        if (((roleCapabilty[role.role]) || []).indexOf(capability) !== -1) {
                                            this.dataObj[capability].push({ selected: true });
                                        } else {
                                            this.dataObj[capability].push({ selected: false });
                                        }
                                    }
                                });

                                const categories = {};
                                Object.keys(this.dataObj).map(obj => {
                                    const cap = this.dataObj[obj][0];
                                    if (!Object.keys(categories).includes(cap.category)) {
                                        categories[cap.category] = [];
                                        let element = {};
                                        element[cap.category] = [{
                                            type: cap.category,
                                            isGroup: true
                                        }];
                                        categories[cap.category].push(element);
                                    }
                                    let element = {};
                                    element[obj] = this.dataObj[obj];
                                    categories[cap.category].push(element);
                                });
                                this.finalList = Object.keys(categories).reduce((a, c) => { return a.concat(categories[c]) }, []);



                                // this.finalList = Object.keys(this.finalList).reduce((a, c: any) => {
                                //     console.log(c);
                                //     a[c.key] = c.value;
                                //     return a;
                                // }, {});

                                // Object.keys(categories).map(catName => {
                                //     console.log(categories[catName]);
                                //     finalGroup.concat(categories[catName]);
                                // });
                            }
                        });
                    }


                    // console.log( this.finalList);

                    //    {
                    //     groupName: 'User Management',
                    //     viewStatus: true,
                    //     configurations: [
                    //         {
                    //             configName: 'Activate/Deactivate User',
                    //             config: [ true, true, true, false]
                    //         },
                    //         {
                    //             configName: 'Bulk Invitations Of User',
                    //             config: [ true, true, true, true, false, true, false, false]
                    //         },
                    //     ]
                    // },

                    if (this.finalList) {

                        if (this.groupTestArray.length > 0) {
                            this.groupTestArray = [];
                        }

                        var groupObj;
                        this.finalList.forEach((element) => {

                            let objValue = Object.values(element);
                            let objKey = Object.keys(element);

                            if (objValue[0][0].isGroup) {
                                if (typeof groupObj === 'object') {
                                    this.groupTestArray.push(groupObj);
                                }

                                groupObj = {};
                                groupObj['groupName'] = objKey[0];
                                groupObj['configurations'] = [];
                                groupObj['viewStatus'] = true;
                                groupObj['colStatus'] = false;
                            } else {
                                let configObj = {
                                    configName: {
                                        category: objValue[0][0].category,
                                        longDesc: objValue[0][0].longDesc,
                                        shortDesc: objValue[0][0].shortDesc,
                                        capability: objKey[0],
                                    },
                                    config: objValue[0]
                                }
                                groupObj['configurations'].push(configObj);
                            }
                        });

                        if (typeof groupObj === 'object') {
                            this.groupTestArray.push(groupObj);
                        }
                        this.groupTestArray.sort(function (a, b) {
                            if (a.groupName < b.groupName) { return -1; }
                            if (a.groupName > b.groupName) { return 1; }
                            return 0;
                        });
                        this.rolesSelecAll();

                        console.log(this.groupTestArray);
                        
                    }

                    this.store.dispatch(new LoaderHide());
                    this.store.dispatch(new LoaderHide());
                });
            });
        });



        // this.store.select(state => state.capabilities.capabilities).subscribe(capabilities => {
        //   console.log(capabilities);
        // });

        // this.store.select(state => state.capabilities.allCapabilitiesOfRoles).subscribe(allCapabilitiesOfRoles => {
        //     console.log(allCapabilitiesOfRoles);
        // });


        // this.store.select(state => state.capabilities.roles).subscribe(roles => {
        //     console.log(roles);
        // });





    }

    groupTestArray = [];

    checkBoolean(value) {
        if (typeof value === 'boolean') {
            return true;
        } else {
            return false;
        }
    }

    setCapability(event, capability, role) {
        const payload = {
            role: role.role,
            capability: Object.keys(capability).length > 0 ? Object.keys(capability)[0] : ''
        };

        const checkedVal = event.checked;
        this.targetId = event.source.id;

        if (typeof checkedVal === 'boolean') {
            this.store.dispatch(new LoaderShow());
            if (checkedVal) {
                this.store.dispatch(new AddCapability(payload));
                this.store.select(state => state.capabilities.addCapResponse).pipe().subscribe(response => {
                    if (typeof response['status'] !== 'undefined') {
                        if (!response['status']) {
                            document.getElementById(event.target.id)['checked'] = false;
                        }
                    }
                });
            } else {
                this.store.dispatch(new RemoveCapability(payload));
                this.store.select(state => state.capabilities.removeCapResponse).pipe().subscribe(response => {
                    if (typeof response['status'] !== 'undefined') {
                        if (!response['status']) {
                            document.getElementById(event.target.id)['checked'] = true;
                        }
                    }
                });
            }
        }
    }

    changeCapabilities() { }

    onAddRoleClick(type, role) {
        if (type == "add") {
            const roleDetails = {};
            this.router.navigate(['../add-role', { roleDetails: JSON.stringify(roleDetails), title: "Add New Role" }], { relativeTo: this.activatedRoute });
        }
        else {
            if (!role) {
                return;
            }
            const roleDetails = {
                role: role.role,
                roleName: role.roleName,
                description: role.description,
                category: role.category
            };
            this.router.navigate(['../add-role', { roleDetails: JSON.stringify(roleDetails), title: "Edit Role" }], { relativeTo: this.activatedRoute });
        }

    }

    onEditRoleClick(role) {
        const roleDetails = {
            role: role.role,
            roleName: role.roleName,
            description: role.description,
            category: role.category
        };
        this.router.navigate(['../edit-role', { roleDetails: JSON.stringify(roleDetails) }], { relativeTo: this.activatedRoute });
    }

    showCapabilityInfo(data) {
        console.log(data);
    }

    getElementValue(element) {
        return Object.keys(element).length > 0 ? element[Object.keys(element)[0]] : [];
    }

    getElementKey(element) {
        return Object.keys(element).length > 0 ? Object.keys(element)[0] : '';
    }

    toggleView(colDataIndex) {
        this.groupTestArray[colDataIndex].viewStatus = !this.groupTestArray[colDataIndex].viewStatus;
    }

    cancel() {
        this.addCapabilities = [];
        this.removeCapabilities = [];
        this.store.dispatch(new GetCapabilities());
        this.store.dispatch(new GetAllCapabilitiesOfRoles());
        this.store.dispatch(new GetAllRoles());
    }



    saveChanges() {
        if (this.addCapabilities.length == 0 && this.removeCapabilities.length == 0) {
            return;
        }

        const payload = {
            addCapabilities: this.addCapabilities,
            removeCapabilities: this.removeCapabilities
        }


        this.store.dispatch(new AddRemoveCapability(payload));
        this.store.select(state => state.capabilities.addRemoveRoleResponse).pipe().subscribe(response => {
            this.addCapabilities = [];
            this.removeCapabilities = [];
            this.store.dispatch(new LoaderShow());

            this.store.dispatch(new GetCapabilities());
            this.store.dispatch(new GetAllCapabilitiesOfRoles());
            this.store.dispatch(new GetAllRoles());
        });

    }

    addCapabilities = [];
    removeCapabilities = [];

    changeCapability(checkedVal, colindex, gindex, cindex) {
        const payload = {
            role: this.rolesList[cindex + 1].role,
            capability: this.groupTestArray[colindex].configurations[gindex].configName.capability
        };

        var checkFlag = checkedVal.currentTarget.checked;
        this.changeCapabilitiesArray(checkFlag, payload);
        this.groupTestArray[colindex].configurations[gindex].config[cindex + 1].selected = checkFlag;
        this.rolesSelecAll();


        // if (checkedVal.currentTarget.checked) {
        //     var found = this.removeCapabilities.some(el => (el.role === payload.role && el.capability === payload.capability ) );
        //     if (found) {
        //         for(var i = 0; i < this.removeCapabilities.length; i++) {
        //             if(this.removeCapabilities[i].role == payload.role && this.removeCapabilities[i].capability == payload.capability) {
        //                 this.removeCapabilities.splice(i, 1);
        //                 break;
        //             }
        //         }
        //     }else {
        //         this.addCapabilities.push(payload);
        //     }

        // } else {
        //     var found = this.addCapabilities.some(el => (el.role === payload.role && el.capability === payload.capability ) );

        //     if (found) {
        //         for(var i = 0; i < this.addCapabilities.length; i++) {
        //             if(this.addCapabilities[i].role == payload.role && this.addCapabilities[i].capability == payload.capability) {
        //                 this.addCapabilities.splice(i, 1);
        //                 break;
        //             }
        //         }
        //     } else {
        //         this.removeCapabilities.push(payload);
        //     }
        // }
    }

    selectAllCapabilities(checkedVal, roleIndex) {
        if (checkedVal.currentTarget.checked) {
            this.groupTestArray.forEach(item => {
                item.configurations.forEach(element => {
                    const payload = {
                        role: this.rolesList[roleIndex].role,
                        capability: element.configName.capability
                    };
                    this.changeCapabilitiesArray(true, payload);
                    element.config[roleIndex].selected = true;
                });
            });
        } else {
            this.groupTestArray.forEach(item => {
                item.configurations.forEach(element => {
                    const payload = {
                        role: this.rolesList[roleIndex].role,
                        capability: element.configName.capability
                    };
                    this.changeCapabilitiesArray(false, payload);
                    element.config[roleIndex].selected = false;
                });
            });
        }

        this.rolesSelecAll();

    }


    changeCapabilitiesArray(checkedVal, payload) {
        if (checkedVal) {
            var found = this.removeCapabilities.some(el => (el.role === payload.role && el.capability === payload.capability));
            if (found) {
                for (var i = 0; i < this.removeCapabilities.length; i++) {
                    if (this.removeCapabilities[i].role == payload.role && this.removeCapabilities[i].capability == payload.capability) {
                        this.removeCapabilities.splice(i, 1);
                        this.addCapabilities.push(payload);

                        break;
                    }
                }
            } else {
                this.addCapabilities.push(payload);
            }

        } else {
            var found = this.addCapabilities.some(el => (el.role === payload.role && el.capability === payload.capability));

            if (found) {
                for (var i = 0; i < this.addCapabilities.length; i++) {
                    if (this.addCapabilities[i].role == payload.role && this.addCapabilities[i].capability == payload.capability) {
                        this.addCapabilities.splice(i, 1);
                        this.removeCapabilities.push(payload);

                        break;
                    }
                }
            } else {
                this.removeCapabilities.push(payload);
            }
        }


    }

    rolesSelecAll() {
        let capabilitiesTotal = 0;
        Object.values(this.capabilitiesList).forEach((capability: any[], index) => {
            capabilitiesTotal = capabilitiesTotal + capability.length;
        });

        this.rolesList.forEach((role, index) => {
            var selectCount = 0;
            this.groupTestArray.forEach((group, groupindex) => {
                group.configurations.forEach((config, configindex) => {
                    if (config.config[index].selected) {
                        selectCount = selectCount + 1;
                    }
                });
            });
            if (selectCount >= capabilitiesTotal - 1) {
                role['selectAll'] = true;
            } else {
                role['selectAll'] = false;
            }
        });
    }

    resetCapabilities() {
        const dialogRef = this.dialog.open(NotificationModalComponent, {
            width: '40%',
            panelClass: 'cmp-modal',
            data: {
              text: 'Are you sure you want to reset all Roles & Permissions ?',
              type: 'publishDoc'
            }
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.store.dispatch(new ResetCapability());
            }
          });
    }

    
    viewLog() {
        this.router.navigateByUrl(`/home/role-management/view-logs`);
    }


}
